import styled from 'styled-components'

export const PointerDiv = styled.div`
    cursor: pointer;
`

export const OptionIconImg = styled.img`
    width: 1.4rem
`